import moment from "../../../node_modules/moment/moment";

export const disabledDateBeforeNow = (current) => {
  const dateNow = moment();
  const currentDate = moment(current);
  const isBefore = currentDate.isBefore(dateNow);
  return isBefore;
};
